const columns: TableColumn[] = [
  {
    Header: `Date`,
    accessor: `endDate`,
    dbKey: `endDate`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },

  {
    Header: `Location Name`,
    accessor: `companyName`,
    dbKey: `companyName`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Billing`,
    accessor: `billing`,
    dbKey: `billing`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Allocated SRT`,
    accessor: `allocatedToken`,
    dbKey: `allocatedToken`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true,
    defaultHidden: true
  },
  {
    Header: `Consumed SRT`,
    accessor: `consumeToken`,
    dbKey: `consumeToken`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true,
    defaultHidden: true
  },
  {
    Header: `Available SRT`,
    accessor: `availableToken`,
    dbKey: `availableToken`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: true,
    defaultHidden: true
  },
  {
    Header: `Lead Count`,
    accessor: `leadCount`,
    dbKey: `leadCount`,
    isString: false,
    isNumeric: true,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Total Cost`,
    accessor: `totalCost`,
    dbKey: `totalCost`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Status`,
    accessor: `status`,
    dbKey: `status`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Invoice approval`,
    accessor: `invoiceApproval`,
    dbKey: `invoiceApproval`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Report approval`,
    accessor: `reportApproval`,
    dbKey: `reportApproval`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Notes`,
    accessor: `notes`,
    dbKey: `notes`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Actions`,
    accessor: `reportAction`,
    dbKey: `reportAction`,
    isString: false,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
